import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModuleVersionOutputRow } from "../types";

const ModuleVersionOutputsTableNameCell = ({
  item: output,
  ...cellProps
}: TableSimpleCellProps<ModuleVersionOutputRow>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{output.id}</TableCellText>
    </TableSimpleCell>
  );
};

export default ModuleVersionOutputsTableNameCell;
